// ALL validation messages

export const isRequired = fieldName => `${fieldName} est obligatoire !`;

export const mustMatch = otherFieldName => {
  return (fieldName) => `${fieldName} must match ${otherFieldName}`;
};

export const minLength = length => {
  return (fieldName) => `${fieldName} doit faire au moins ${length} caractères`;
};

export const eqLength = length => {
  return (fieldName) => `${fieldName} doit faire ${length} caractères`;
};

export const regexMatch = (message) => {
  return (fieldName) => `${message}`;
};


// WEBPACK FOOTER //
// ./src/components/Validation/ErrorMessages.js